import React from 'react'

export interface CardItem {
    name?: string;
    qty?: number;
}

interface CardOrderProps {
    listBook: CardItem[]
}

const CardOrder = ({ listBook }: CardOrderProps) => {
    return (
        <>
            {listBook.map((book, index) => (
                <div className='w-full inline-flex gap-3 items-center bg-white p-3 rounded-[4px] justify-between '>
                    <div className="inline-flex gap-3 items-center flex-1 ">
                        <p className='shadowCard p-1 text-text-blue-200 title1medium rounded-[4px] min-w-[40px] text-center'>{index + 1}</p>
                        <p className=' line-clamp-2  min-w-0 flex-1 title2medium'>{book.name}</p>

                    </div>
                    <p className='body1 text-text-grey'>X{book.qty}</p>

                </div>
            ))}
        </>
    )
}

export default CardOrder
